import { useQuery } from '@tanstack/react-query';
import { rolesDetailService } from '../services/rolesDetail.service';

export function useRolesDetail(id: string | null) {
  const roleQuery = useQuery({
    queryKey: ['settings', 'roles', 'detail', id],
    queryFn: () => rolesDetailService.getRoleById(id || ''),
    enabled: Boolean(id),
  });

  return {
    role: roleQuery.data || null,
    isLoading: roleQuery.isLoading,
    error: roleQuery.error instanceof Error ? roleQuery.error.message : null,
  };
}
